import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './styles/Link.module.css';

const Link = ({ redirectTo }) => {
    const navigate = useNavigate();

    return (
        <div className={styles.link}>
            <button onClick={() => navigate(redirectTo)}>
                <img src='/images/common/voltar.svg' alt='Voltar' />
            </button>
        </div>
    );
}

export default Link;